<template>
  <div>
    <img
      v-if="imgUrl"
      :src="imgUrl"
      alt=""
    >
    <v-icon v-else>
      mdi-image-off-outline
    </v-icon>
  </div>
</template>

<script>
export default {
    props: {
        imgId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            imgUrl: '',
        };
    },
    async mounted() {
        if (this.imgId) {
            this.imgUrl = await this.$rq.getFileUrl(this.imgId);
        }
    },
};
</script>

<style lang="scss" scoped>
  img {
    max-width: 100%;
  }
</style>
